import React from 'react';

import createHeartComponent from '@finn-no/favorite-heart-component';
import {
  BapSearchAd,
  AdImage
} from '@schibsted-nmp/search-frontend-components/react';

export type SimpleBapSearchAdProps = {
  layout?: 'grid' | 'list';
  onClick?: () => void;
};

type LabelRenderProps = {
  className?: string;
  classes: {
    badge: string;
    info: string;
    warning: string;
    success: string;
    [key: string]: string;
  };
};

export function SponsoredListingAd({
  layout = 'grid',
  onClick
}: SimpleBapSearchAdProps) {
  const mockAds = [
    {
      ad_id: 'martailer-placeholder-001',
      canonical_url: '#',
      distance: null,
      extras: [],
      flags: [],
      heading: 'Terror of The Peaks (2021 Core Set)',
      image: {
        aspect_ratio: 1.3333333333333333,
        height: 533,
        url: 'https://cards.scryfall.io/normal/front/4/3/432ecd5f-966f-4403-a973-51e175a524a0.jpg?1594736810',
        width: 400
      },
      labels: [
        {
          id: 'paid_position',
          label: 'Paid Position',
          type: 'PRIMARY'
        }
      ],
      location: 'Stockholm',
      main_search_key: 'SEARCH_ID_BAP_COMMON',
      organisation_name: "Dragon's Lair",
      price: {
        currency_code: 'SEK',
        amount: 818.0,
        price_unit: 'kr'
      },
      timestamp: 1234567890,
      trade_type: 1
    },
    {
      ad_id: 'martailer-placeholder-002',
      canonical_url: '#',
      distance: null,
      extras: [],
      flags: [],
      heading: 'Black Lotus - Unlimited Edition',
      image: {
        aspect_ratio: 1.3333333333333333,
        height: 533,
        url: 'https://cards.scryfall.io/normal/front/4/a/4a2e428c-dd25-484c-bbc8-2d6ce10ef42c.jpg?1559591808',
        width: 400
      },
      labels: [
        {
          id: 'paid_position',
          label: 'Paid Position',
          type: 'PRIMARY'
        }
      ],
      location: 'Gothenburg',
      main_search_key: 'SEARCH_ID_BAP_COMMON',
      organisation_name: 'Collector Cards AB',
      price: {
        currency_code: 'SEK',
        amount: 125000.0,
        price_unit: 'kr'
      },
      timestamp: 1234567890,
      trade_type: 1
    },
    {
      ad_id: 'martailer-placeholder-003',
      canonical_url: '#',
      distance: null,
      extras: [],
      flags: [],
      heading: 'Tarmogoyf - Modern Masters',
      image: {
        aspect_ratio: 1.3333333333333333,
        height: 533,
        url: 'https://cards.scryfall.io/normal/front/1/c/1cfdd410-391b-4b71-8139-f5a30653097a.jpg?1562259658',
        width: 400
      },
      labels: [
        {
          id: 'paid_position',
          label: 'Paid Position',
          type: 'PRIMARY'
        }
      ],
      location: 'Malmö',
      main_search_key: 'SEARCH_ID_BAP_COMMON',
      organisation_name: 'Magic Corner',
      price: {
        currency_code: 'SEK',
        amount: 1499.0,
        price_unit: 'kr'
      },
      timestamp: 1234567890,
      trade_type: 1
    }
  ];

  const mockAd = mockAds[Math.floor(Math.random() * mockAds.length)];
  if (!mockAd) return null;

  const IMAGE_SIZES =
    '(min-width: 1300px) 306px, (min-width: 1010px) 316px, (min-width: 768px) 33vw, (min-width: 480px) 50vw, 100vw';

  const Heart = createHeartComponent({
    userId: '12345',
    baseUri: '',
    redirectUrl: ''
  });

  return (
    <BapSearchAd
      ad={mockAd}
      currentTime={Date.now()}
      favorite={() => (
        <Heart
          variant={layout === 'grid' ? 'heart-on-image' : 'heart'}
          itemId={parseInt(mockAd.ad_id.split('-').pop() || '0', 10)}
          itemType="Ad"
          buttonClass=""
          locale="sv"
          isMobile={false}
        />
      )}
      id={mockAd.ad_id}
      imageSizes={IMAGE_SIZES}
      label={(props: LabelRenderProps) => (
        <span
          className={`${props.className} ${props.classes.badge} ${props.classes.info}`}
        >
          Paid Position
        </span>
      )}
      layout={layout}
      onClick={onClick}
      url={mockAd.canonical_url}
      image={
        layout === 'grid'
          ? () => (
              <AdImage
                aspectClass="aspect-3/4"
                height={mockAd.image.height}
                width={mockAd.image.width}
                url={mockAd.image.url}
                crop={true}
                sizes={IMAGE_SIZES}
              />
            )
          : undefined
      }
    />
  );
}
